import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import ResponsiveImage from './ResponsiveImage';
import useStyles from '../styles';

export const DisplayMedia = ({ media, onClick, maxHeight }) => {
  const { appDetailsYoutubeWrapper, appDetailsYoutubeFrame } = useStyles();

  return (
    <Choose>
      <When condition={media.type === 'youtube'}>
        <div className={appDetailsYoutubeWrapper}>
          <iframe className={appDetailsYoutubeFrame} allowFullScreen src={media.url} title={media.altText} />
        </div>
      </When>
      <Otherwise>
        <Box display="grid" placeItems="center" onClick={onClick}>
          <ResponsiveImage alt={media.altText} src={media.url} maxHeight={maxHeight || 'auto'} />
        </Box>
      </Otherwise>
    </Choose>
  );
};
DisplayMedia.propTypes = {
  media: PropTypes.shape({
    url: PropTypes.string,
    type: PropTypes.string,
    altText: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  maxHeight: PropTypes.string,
};

DisplayMedia.defaultProps = {
  onClick: null,
  maxHeight: null,
};

export default DisplayMedia;
